"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _glamor = require("glamor");

var _components = require("components");

var _PageTitle = require("@quixeltools/quixel-ui-library/dist/components/common/website/PageTitle");

var _PageTitle2 = _interopRequireDefault(_PageTitle);

var _Hr = require("@quixeltools/quixel-ui-library/dist/components/common/website/Hr");

var _Hr2 = _interopRequireDefault(_Hr);

var _Link = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/Link");

var _Link2 = _interopRequireDefault(_Link);

var _Button = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/Button");

var _Button2 = _interopRequireDefault(_Button);

var _css = require("@quixeltools/quixel-ui-library/dist/utils/css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// const docxLink = 'https://d3uwib8iif8w1p.cloudfront.net/docs/QuixelMegascansToS_MAY172018.docx';
var pdfLink = "https://d3uwib8iif8w1p.cloudfront.net/docs/QuixelMegascansToSApril172019.pdf";
// const docxLinkEULA ='https://d3uwib8iif8w1p.cloudfront.net/docs/QuixelFreeAssetsEULAOCT302017.doc'
var pdfLinkEULA = "https://d3uwib8iif8w1p.cloudfront.net/docs/QuixelFreeAssetsEULAOCT302017.pdf";
var cloudfrontThumbs = function cloudfrontThumbs(path) {
  return "https://cdn.quixel.com/quixel/thumbs/" + path;
};

var tos = (0, _glamor.css)({
  margin: "0 auto",
  maxWidth: "957px",
  width: "70%",
  marginBottom: "9rem"
}, (0, _css.minWidth)(_css.breakpoints.xxlarge)({
  marginTop: "9rem"
}));

var para = (0, _glamor.css)({
  color: _css.pallets.gray_text,
  fontSize: (0, _css.unitRem)(0.875),
  lineHeight: (0, _css.unitRem)(1.2),
  marginTop: (0, _css.unitRem)(1),
  marginBottom: (0, _css.unitRem)(1),
  "& strong": {
    fontWeight: 700
  }
}, (0, _css.maxWidth)(_css.breakpoints.mediumlarge)({
  fontSize: (0, _css.unitRem)(0.7)
}));

var content = (0, _glamor.css)({
  "& h1": {
    color: _css.pallets.gray_text,
    fontSize: (0, _css.unitRem)(1.4),
    lineHeight: (0, _css.unitRem)(1.2),
    marginTop: (0, _css.unitRem)(1),
    marginBottom: (0, _css.unitRem)(1)
  },
  "& p": {
    color: _css.pallets.gray_text,
    fontSize: (0, _css.unitRem)(0.875),
    lineHeight: (0, _css.unitRem)(1.2),
    marginTop: (0, _css.unitRem)(1),
    marginBottom: (0, _css.unitRem)(1)
  },
  "& ol": {
    counterReset: "item"
  },
  "& ul": {
    listStyleType: "circle",
    marginLeft: "2rem",
    color: _css.pallets.gray_text
  },
  "& li": {
    fontSize: (0, _css.unitRem)(0.875),
    lineHeight: (0, _css.unitRem)(1.2),

    ":before": {
      position: "relative",
      color: _css.pallets.gray_text,
      // content: 'counters(item, ".")". "',
      // counterIncrement: 'item',
      fontSize: (0, _css.unitRem)(0.875),
      lineHeight: (0, _css.unitRem)(1.2),
      // left: '-2.2rem',
      // top: '3.3rem',

      "& strong": {
        fontWeight: 600
      }
    }
  },
  "& strong": {
    fontWeight: 600
  }
}, (0, _css.maxWidth)(_css.breakpoints.mediumlarge)({
  "& h1": {
    fontSize: (0, _css.unitRem)(1.1)
  },
  "& p": {
    fontSize: (0, _css.unitRem)(0.7)
  },
  "& li": {
    ":before": {
      fontSize: (0, _css.unitRem)(0.7)
    }
  }
}));
var _link = (0, _glamor.css)({
  transition: "color 0.2s ease-in-out",
  ":hover": {
    color: "#fff!important"
  }
});
var ol = (0, _glamor.css)({
  counterReset: "item",
  "& ul": {
    counterReset: "none"
  },
  "& ul li:before": {
    content: "none",
    counterIncrement: "none"
  }
});

var li = (0, _glamor.css)({
  ":before": {
    position: "relative",
    color: _css.pallets.gray_text,
    content: 'counters(item, ".")". "',
    counterIncrement: "item",
    fontSize: (0, _css.unitRem)(0.875),
    lineHeight: (0, _css.unitRem)(1.2),
    left: "-3.2rem",
    top: "3.3rem",

    "& strong": {
      fontWeight: 600
    }
  }
}, (0, _css.maxWidth)(_css.breakpoints.mediumlarge)({
  ":before": {
    fontSize: (0, _css.unitRem)(0.7)
  }
}));

var _hr = (0, _glamor.css)({
  marginTop: (0, _css.unitRem)(3),
  marginBottom: (0, _css.unitRem)(3)
});
var privacy = (0, _glamor.css)({
  margin: "0 auto",
  maxWidth: "70%"
});

var button = (0, _glamor.css)({
  marginRight: (0, _css.unitRem)(1)
});

var refund = (0, _glamor.css)({
  margin: (0, _css.unitRem)(5) + " auto",
  marginTop: 0,
  maxWidth: "74%"
});

var strong = (0, _glamor.css)({
  fontWeight: 600
});

var downloadButtons = (0, _glamor.css)({
  margin: (0, _css.unitRem)(2) + " 0",
  textAlign: "left"
});

var contactUs = (0, _glamor.css)({
  margin: "0 auto",
  marginBottom: (0, _css.unitRem)(5),
  textAlign: "center",
  maxWidth: "74%"
});
var _col = (0, _glamor.css)({
  paddingLeft: "1.1rem",
  flexBasis: "33.3333%",
  border: "1px " + _css.pallets.gray_text + " solid",
  color: "" + _css.pallets.gray_text,
  "& p": {
    wordBreak: "break-word"
  }
}, (0, _css.maxWidth)(_css.breakpoints.mediumlarge)({
  paddingLeft: "0.7rem",
  "& p": {
    fontSize: (0, _css.unitRem)(0.01),
    lineHeight: (0, _css.unitRem)(0.7),
    "& ul": {
      fontSize: (0, _css.unitRem)(0.01),
      lineHeight: (0, _css.unitRem)(0.7),
      marginLeft: 7,
      "& li": {
        fontSize: (0, _css.unitRem)(0.01),
        lineHeight: (0, _css.unitRem)(0.7)
      }
    }
  },
  "& ul": {
    fontSize: (0, _css.unitRem)(0.01),
    lineHeight: (0, _css.unitRem)(0.7),
    marginLeft: 7,
    "& li": {
      fontSize: (0, _css.unitRem)(0.01),
      lineHeight: (0, _css.unitRem)(0.7)
    }
  }
}));
var heading = (0, _glamor.css)({
  textAlign: "center",
  flexBasis: "33.3333%",
  border: "1px " + _css.pallets.gray_text + " solid",
  color: "" + _css.pallets.gray_text
}, (0, _css.maxWidth)(_css.breakpoints.mediumlarge)({
  "& p": {
    fontSize: (0, _css.unitRem)(0.01)
  }
}));

var ToS = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(ToS, _Component);

  function ToS(props) {
    (0, _classCallCheck3.default)(this, ToS);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ToS.__proto__ || (0, _getPrototypeOf2.default)(ToS)).call(this, props));

    _this.onTosQuery = _this.onTosQuery.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(ToS, [{
    key: "onTosQuery",
    value: function onTosQuery() {
      this.context.dialogs.custom(_react2.default.createElement(_components.ContactUsPopupContainer, {
        title: "Have a query about our ToS?",
        description: "We would be happy to provide answers regarding our Terms of Service. Leave us a note and we will get back to you soon.",
        tag: "TermsOfService",
        initialValues: { name: "", email: "", subject: "", comment: "" }
      }));
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        _components.AppSideEffects,
        {
          documentTitle: " Legal - End user license agreement & privacy policy",
          documentImage: cloudfrontThumbs("page-thumb-legal.jpg"),
          documentDescription: "Review the terms and conditions of Quixel’s limited warranty; including limitations and exclusions for all our products."
        },
        _react2.default.createElement(
          "div",
          null,
          _react2.default.createElement(_components.SiteHeaderGap, null),
          _react2.default.createElement(
            "section",
            { id: "privacy-policy", className: tos },
            _react2.default.createElement(_PageTitle2.default, {
              align: "left",
              dateTop: true,
              title: "PRIVACY POLICY",
              subTitle: "NOV 12TH 2019"
            }),
            _react2.default.createElement(
              "div",
              { className: content },
              _react2.default.createElement(
                "h1",
                { className: "p1" },
                _react2.default.createElement(
                  "strong",
                  null,
                  "Introduction"
                )
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "Our Privacy Policy is designed to help you understand what personally identifiable information we collect, how we use it and what rights you have."
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "For the purposes of applicable data protection legislation the relevant Epic entity identified for your region in the \u201CContact\u201D section of the policy below is the controller of personal data provided by you and determines how and why your personal data will be processed."
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "Please note that this Privacy Policy applies to the following internet sites:"
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                _react2.default.createElement(
                  _Link2.default,
                  { href: "/", className: _link },
                  "www.quixel.com"
                )
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "Should you have any questions about our processing of personal data or about this Privacy Policy, please refer to the last section on how to get in touch."
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "When we talk about the\xA0",
                _react2.default.createElement(
                  "strong",
                  null,
                  "\u201CServices\u201D"
                ),
                "\xA0in this policy, we are referring to our websites, softwares and copyright assets and other services which we have licensed to our Customers. When we talk about\xA0",
                _react2.default.createElement(
                  "strong",
                  null,
                  "\u201CPersonal Data\u201D"
                ),
                "\xA0in this policy, we are referring to personally identifiable information you provide when using our Services or in any other contact with us, except for any anonymised Personal Data. When we talk about\xA0",
                _react2.default.createElement(
                  "strong",
                  null,
                  "\u201CAffiliated Parties\u201D"
                ),
                "\xA0in this policy, we are referring to our partners, affiliated companies and third parties."
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "PLEASE READ THIS PRIVACY POLICY BEFORE USING OUR SERVICES. IF YOU DO NOT AGREE WITH THIS PRIVACY POLICY, PLEASE DO NOT USE THE SERVICES."
              ),
              _react2.default.createElement(
                "p",
                { className: "li1" },
                _react2.default.createElement(
                  "strong",
                  null,
                  "1. What Personal Data we collect?"
                )
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "We collect and process the following types of personal data about you:"
              ),
              _react2.default.createElement(
                "ul",
                { className: "ul1" },
                _react2.default.createElement(
                  "ul",
                  { className: "ul1" },
                  _react2.default.createElement(
                    "li",
                    { className: "li1" },
                    _react2.default.createElement(
                      "strong",
                      null,
                      "Identification Data"
                    ),
                    "\xA0such as your name, street address, postal code, city, country, email address and project name."
                  ),
                  _react2.default.createElement(
                    "li",
                    { className: "li1" },
                    _react2.default.createElement(
                      "strong",
                      null,
                      "Contact Data"
                    ),
                    "\xA0such as your billing address, and email address."
                  ),
                  _react2.default.createElement(
                    "li",
                    { className: "li1" },
                    _react2.default.createElement(
                      "strong",
                      null,
                      "Financial Data"
                    ),
                    "\xA0such as your payment card details."
                  ),
                  _react2.default.createElement(
                    "li",
                    { className: "li1" },
                    _react2.default.createElement(
                      "strong",
                      null,
                      "Transaction Data"
                    ),
                    "\xA0such as details about payments between you and us and other details of purchases made by you."
                  ),
                  _react2.default.createElement(
                    "li",
                    { className: "li1" },
                    _react2.default.createElement(
                      "strong",
                      null,
                      "Technical Data"
                    ),
                    "\xA0such as your login data, internet protocol addresses, browser type and version, operating system and platform and other technology on the devices you use to access our Services."
                  ),
                  _react2.default.createElement(
                    "li",
                    { className: "li1" },
                    _react2.default.createElement(
                      "strong",
                      null,
                      "Profile Data"
                    ),
                    "\xA0such as your username and password, purchases or orders, your interests, preferences, feedback and survey responses."
                  ),
                  _react2.default.createElement(
                    "li",
                    { className: "li1" },
                    _react2.default.createElement(
                      "strong",
                      null,
                      "Usage Data"
                    ),
                    "\xA0such as information about how you use our website, products and Services."
                  ),
                  _react2.default.createElement(
                    "li",
                    { className: "li1" },
                    _react2.default.createElement(
                      "strong",
                      null,
                      "Marketing and Communications Data"
                    ),
                    "\xA0such as your preferences in receiving marketing communications from us and your communication preferences."
                  )
                )
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "We do not collect any Sensitive Data about you. Sensitive data refers to data that includes details about your race or ethnicity, religious or philosophical beliefs, sex life, sexual orientation, political opinions, trade union membership, information about your health and genetic and biometric data. We do not collect any information about criminal convictions and offences."
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "We only collect Personal Data that it deems to be reasonably necessary to fulfill your online requests and our legitimate business objectives."
              ),
              _react2.default.createElement(
                "p",
                { className: "li1" },
                _react2.default.createElement(
                  "strong",
                  null,
                  "2. How we collect your Personal Data?"
                )
              ),
              _react2.default.createElement(
                "ul",
                { className: "ul1" },
                _react2.default.createElement(
                  "li",
                  { className: "li1" },
                  _react2.default.createElement(
                    "strong",
                    null,
                    "Direct interactions:\xA0"
                  ),
                  "You may provide data by filling in forms on our site (or otherwise) or by communicating with us by email or otherwise, including when you:"
                ),
                _react2.default.createElement(
                  "ul",
                  { className: "ul1" },
                  _react2.default.createElement(
                    "li",
                    { className: "li1" },
                    "Order our products or Services;"
                  ),
                  _react2.default.createElement(
                    "li",
                    { className: "li1" },
                    "Create an account on any of our sites;"
                  ),
                  _react2.default.createElement(
                    "li",
                    { className: "li1" },
                    "Subscribe to our Services or publications;"
                  ),
                  _react2.default.createElement(
                    "li",
                    { className: "li1" },
                    "Request resources or marketing be sent to you;"
                  ),
                  _react2.default.createElement(
                    "li",
                    { className: "li1" },
                    "Enter a competition, prize draw, promotion or survey; or"
                  ),
                  _react2.default.createElement(
                    "li",
                    { className: "li1" },
                    "Give us feedback."
                  )
                ),
                _react2.default.createElement(
                  "li",
                  { className: "li1" },
                  _react2.default.createElement(
                    "strong",
                    null,
                    "Automated technologies or interactions:\xA0"
                  ),
                  "As you use our Services, we may automatically collect Technical Data about your equipment, browsing actions and usage patterns. We collect this data by using cookies, server logs and Google Analytics. Please see our cookie policy at\xA0",
                  _react2.default.createElement(
                    _Link2.default,
                    { href: "/cookiepolicy", className: _link },
                    "Cookie policy"
                  ),
                  "\xA0for further details."
                )
              ),
              _react2.default.createElement(
                "p",
                { className: "li1" },
                _react2.default.createElement(
                  "strong",
                  null,
                  "3. How and why we use your Personal Data?"
                )
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "Set out below is a description of the ways we intend to use your personal data and the legal grounds on which we will process such data. We have also explained what our legitimate interests are where relevant. The Type of Data in the chart below refers to the definitions described under section 1."
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "The most common legal/lawful grounds of our processing of your personal data are:"
              ),
              _react2.default.createElement(
                "ul",
                { className: "ul1" },
                _react2.default.createElement(
                  "ul",
                  { className: "ul1" },
                  _react2.default.createElement(
                    "li",
                    { className: "li1" },
                    "Where we need to perform the contract between us."
                  ),
                  _react2.default.createElement(
                    "li",
                    { className: "li1" },
                    "Where it is necessary for our legitimate interests (or those of a third party) and your interests and fundamental rights do not override those interests."
                  ),
                  _react2.default.createElement(
                    "li",
                    { className: "li1" },
                    "Where we need to comply with a legal or regulatory obligation."
                  )
                )
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "We may process your personal data for more than one lawful ground, depending on the specific purpose for which we are using your data. Please email us at\xA0",
                _react2.default.createElement(
                  _Link2.default,
                  {
                    className: _link,
                    target: "_blank",
                    href: "mailto:legal@quixel.se"
                  },
                  "legal@quixel.se"
                ),
                "\xA0if you need details about the specific legal ground we are relying on to process your personal data where more than one ground has been set out in the table below."
              ),
              _react2.default.createElement(
                "p",
                null,
                _react2.default.createElement(
                  "div",
                  {
                    className: (0, _glamor.css)({
                      fontSize: (0, _css.unitRem)(0.875),
                      width: "126%",
                      marginLeft: "-16%",
                      display: "flex",
                      flexWrap: "wrap",
                      color: "" + _css.pallets.gray_text
                    }, (0, _css.maxWidth)(_css.breakpoints.mediumlarge)({
                      fontSize: (0, _css.unitRem)(0.7),
                      marginLeft: "-12%"
                    }))
                  },
                  _react2.default.createElement(
                    "div",
                    { className: heading },
                    _react2.default.createElement(
                      "p",
                      null,
                      _react2.default.createElement(
                        "strong",
                        null,
                        "Purpose/Activity"
                      )
                    )
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: heading },
                    _react2.default.createElement(
                      "p",
                      null,
                      _react2.default.createElement(
                        "strong",
                        null,
                        "Type of Data"
                      )
                    )
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: heading },
                    _react2.default.createElement(
                      "p",
                      null,
                      _react2.default.createElement(
                        "strong",
                        null,
                        "Lawful Basis for Processing"
                      )
                    )
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: _col },
                    _react2.default.createElement(
                      "p",
                      null,
                      "To register you as a new customer"
                    )
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: _col },
                    _react2.default.createElement(
                      "ul",
                      null,
                      _react2.default.createElement(
                        "li",
                        null,
                        "Identification Data"
                      ),
                      _react2.default.createElement(
                        "li",
                        null,
                        "Contact Data"
                      )
                    )
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: _col },
                    _react2.default.createElement(
                      "p",
                      null,
                      "Performance of a contract with you"
                    )
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: _col },
                    _react2.default.createElement(
                      "p",
                      null,
                      "To process your order including:",
                      _react2.default.createElement(
                        "ul",
                        null,
                        _react2.default.createElement(
                          "li",
                          null,
                          "Manage payments, fees and charges"
                        )
                      )
                    )
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: _col },
                    _react2.default.createElement(
                      "p",
                      null,
                      _react2.default.createElement(
                        "ul",
                        null,
                        _react2.default.createElement(
                          "li",
                          null,
                          "Identification Data"
                        ),
                        _react2.default.createElement(
                          "li",
                          null,
                          "Contact Data"
                        ),
                        _react2.default.createElement(
                          "li",
                          null,
                          "Financial Data"
                        ),
                        _react2.default.createElement(
                          "li",
                          null,
                          "Transaction Data"
                        )
                      )
                    )
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: _col },
                    _react2.default.createElement(
                      "p",
                      null,
                      "Performance of a contract with you"
                    )
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: _col },
                    _react2.default.createElement(
                      "p",
                      null,
                      "To manage our business relationship with you which will include:",
                      _react2.default.createElement(
                        "ul",
                        null,
                        _react2.default.createElement(
                          "li",
                          null,
                          "Notifying you about changes to our terms or privacy policy"
                        ),
                        _react2.default.createElement(
                          "li",
                          null,
                          "Asking you to leave a review or take a survey"
                        ),
                        _react2.default.createElement(
                          "li",
                          null,
                          "To send you product and company updates"
                        )
                      )
                    )
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: _col },
                    _react2.default.createElement(
                      "p",
                      null,
                      _react2.default.createElement(
                        "ul",
                        null,
                        _react2.default.createElement(
                          "li",
                          null,
                          "Identification Data"
                        ),
                        _react2.default.createElement(
                          "li",
                          null,
                          "Contact Data"
                        ),
                        _react2.default.createElement(
                          "li",
                          null,
                          "Profile Data"
                        ),
                        _react2.default.createElement(
                          "li",
                          null,
                          "Marketing and Communications Data"
                        )
                      )
                    )
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: _col },
                    _react2.default.createElement(
                      "p",
                      null,
                      _react2.default.createElement(
                        "ul",
                        null,
                        _react2.default.createElement(
                          "li",
                          null,
                          "Performance of a contract with you"
                        ),
                        _react2.default.createElement(
                          "li",
                          null,
                          "Necessary to comply with a legal obligation, i.e. due to product liability, data protection legislation or accounting legislation."
                        ),
                        _react2.default.createElement(
                          "li",
                          null,
                          "Necessary for our legitimate interests to keep our records updated and to study how customers use our products/services"
                        )
                      )
                    )
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: _col },
                    _react2.default.createElement(
                      "p",
                      null,
                      "To enable you to partake in a prize draw, competition or complete a survey"
                    )
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: _col },
                    _react2.default.createElement(
                      "p",
                      null,
                      _react2.default.createElement(
                        "ul",
                        null,
                        _react2.default.createElement(
                          "li",
                          null,
                          "Identification Data"
                        ),
                        _react2.default.createElement(
                          "li",
                          null,
                          "Contact Data"
                        ),
                        _react2.default.createElement(
                          "li",
                          null,
                          "Profile Data"
                        ),
                        _react2.default.createElement(
                          "li",
                          null,
                          "Usage Data"
                        ),
                        _react2.default.createElement(
                          "li",
                          null,
                          "Marketing and Communications Data"
                        )
                      )
                    )
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: _col },
                    _react2.default.createElement(
                      "p",
                      null,
                      _react2.default.createElement(
                        "ul",
                        null,
                        _react2.default.createElement(
                          "li",
                          null,
                          "Performance of a contract with you"
                        ),
                        _react2.default.createElement(
                          "li",
                          null,
                          "Necessary for our legitimate interests to study how customers use our products/services, to develop them and grow our business",
                          " "
                        ),
                        _react2.default.createElement(
                          "li",
                          null,
                          "Based on consent from you"
                        )
                      )
                    )
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: _col },
                    _react2.default.createElement(
                      "p",
                      null,
                      "To administer and protect our business and our Services (including troubleshooting, testing, system maintenance, support, reporting and hosting of data)"
                    )
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: _col },
                    _react2.default.createElement(
                      "p",
                      null,
                      _react2.default.createElement(
                        "ul",
                        null,
                        _react2.default.createElement(
                          "li",
                          null,
                          "Identification Data"
                        ),
                        _react2.default.createElement(
                          "li",
                          null,
                          "Contact Data"
                        ),
                        _react2.default.createElement(
                          "li",
                          null,
                          "Technical Data"
                        )
                      )
                    )
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: _col },
                    _react2.default.createElement(
                      "p",
                      null,
                      "Performance of a contract with you"
                    )
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: _col },
                    _react2.default.createElement(
                      "p",
                      null,
                      "To use data analytics to improve or develop our website, products/Services, marketing, customer relationships and experiences"
                    )
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: _col },
                    _react2.default.createElement(
                      "p",
                      null,
                      _react2.default.createElement(
                        "ul",
                        null,
                        _react2.default.createElement(
                          "li",
                          null,
                          "Technical Data"
                        ),
                        _react2.default.createElement(
                          "li",
                          null,
                          "Usage Data"
                        )
                      )
                    )
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: _col },
                    _react2.default.createElement(
                      "p",
                      null,
                      "Necessary for our legitimate interests to define types of customers for our products and Services, to keep our site updated and relevant, to develop our business and to inform our marketing strategy"
                    )
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: _col },
                    _react2.default.createElement(
                      "p",
                      null,
                      "To make suggestions and recommendations to you about our different goods or services that may be of interest to you"
                    )
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: _col },
                    _react2.default.createElement(
                      "p",
                      null,
                      _react2.default.createElement(
                        "ul",
                        null,
                        _react2.default.createElement(
                          "li",
                          null,
                          "Identification Data"
                        ),
                        _react2.default.createElement(
                          "li",
                          null,
                          "Contact Data"
                        ),
                        _react2.default.createElement(
                          "li",
                          null,
                          "Technical Data"
                        ),
                        _react2.default.createElement(
                          "li",
                          null,
                          "Usage Data"
                        ),
                        _react2.default.createElement(
                          "li",
                          null,
                          "Profile Data"
                        ),
                        _react2.default.createElement(
                          "li",
                          null,
                          "Marketing and Communications Data"
                        )
                      )
                    )
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: _col },
                    _react2.default.createElement(
                      "p",
                      null,
                      "Necessary for our legitimate interests to develop our products/services and grow our business"
                    )
                  )
                )
              ),
              _react2.default.createElement(
                "ul",
                null,
                _react2.default.createElement(
                  "li",
                  { className: "li1" },
                  _react2.default.createElement(
                    "strong",
                    null,
                    "Marketing communications"
                  )
                )
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "You will receive marketing communications from us if you have:"
              ),
              _react2.default.createElement(
                "ul",
                { className: "ul1" },
                _react2.default.createElement(
                  "ul",
                  { className: "ul1" },
                  _react2.default.createElement(
                    "ul",
                    { className: "ul1" },
                    _react2.default.createElement(
                      "li",
                      { className: "li1" },
                      "Requested information from us or purchased goods or Services from us; or"
                    ),
                    _react2.default.createElement(
                      "li",
                      { className: "li1" },
                      "If you provided us with your details and ticked the box at the point of entry of your details for us to send you marketing communications, e.g. when you purchased goods or Services, or when you registered for subscription; and"
                    ),
                    _react2.default.createElement(
                      "li",
                      { className: "li1" },
                      "In each case, you have not opted out of receiving that marketing."
                    )
                  )
                )
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "We will get your express opt-in consent before we share your personal data with any third party for their or other third party marketing purposes. Generally, we do not rely on consent as a legal ground for processing your personal data, other than in relation to sending marketing communications to you via email."
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "You have the right to withdraw consent to marketing at any time. You can ask us to stop sending you marketing messages by following the opt-out links on any marketing message sent to you or by emailing us at\xA0",
                _react2.default.createElement(
                  _Link2.default,
                  {
                    className: _link,
                    target: "_blank",
                    href: "mailto:legal@quixel.se"
                  },
                  "legal@quixel.se"
                )
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "Where you opt out of receiving our marketing communications, this will not apply to personal data provided to us as a result of a product/Service purchase, product/Service experience or other transactions."
              ),
              _react2.default.createElement(
                "ul",
                { className: "ul1" },
                _react2.default.createElement(
                  "ul",
                  { className: "ul1" },
                  _react2.default.createElement(
                    "li",
                    { className: "li1" },
                    _react2.default.createElement(
                      "strong",
                      null,
                      "Change of purpose"
                    )
                  )
                )
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "We will only use your personal data for the purposes for which we collected it, unless we reasonably consider that we need to use it for another reason and that reason is compatible with the original purpose. If you wish to find out more about how the processing for the new purpose is compatible with the original purpose, please email us at\xA0",
                _react2.default.createElement(
                  _Link2.default,
                  {
                    className: _link,
                    target: "_blank",
                    href: "mailto:legal@quixel.se"
                  },
                  "legal@quixel.se"
                )
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "If we need to use your personal data for a purpose unrelated to the purpose for which we collected the data, we will notify you and we will explain the legal ground of processing."
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "We may process your personal data without your knowledge or consent where this is required or permitted by law."
              ),
              _react2.default.createElement(
                "p",
                { className: "li1" },
                _react2.default.createElement(
                  "strong",
                  null,
                  "4. Cookies and Logs"
                )
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "A cookie is information a website places on your computer\u2019s hard drive so that the website is able to remember your preferences and/or which pages you visited on the website and make your visit more efficient and enjoyable."
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "Wel may use cookies to determine the number of unique visitors to our Service over a given period, or to remember user account details, etc. so that the need for multiple log-ins is eliminated. We may combine information collected through cookies to any personal information submitted online when using the Service to help personalize your access to and use of the Service. Cookies may be disabled on your computer by indicating this in the preferences or options menus in your browser."
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "We may collect data in the form of logs. Log data collected on web servers supplies us with aggregate information about the number of visits to different pages on the Service and other navigational data. The variety of technical information we may log is:"
              ),
              _react2.default.createElement(
                "ul",
                { className: "ul1" },
                _react2.default.createElement(
                  "ul",
                  { className: "ul1" },
                  _react2.default.createElement(
                    "li",
                    { className: "li1" },
                    "IP address"
                  ),
                  _react2.default.createElement(
                    "li",
                    { className: "li1" },
                    "Device information, including device name and IDs, hardware model, operating system and version, and mobile network information"
                  ),
                  _react2.default.createElement(
                    "li",
                    { className: "li1" },
                    "Browser information"
                  ),
                  _react2.default.createElement(
                    "li",
                    { className: "li1" },
                    "Cookie information"
                  ),
                  _react2.default.createElement(
                    "li",
                    { className: "li1" },
                    "Date/time of access"
                  ),
                  _react2.default.createElement(
                    "li",
                    { className: "li1" },
                    "Requested page(s)"
                  ),
                  _react2.default.createElement(
                    "li",
                    { className: "li1" },
                    "Referring page(s)"
                  )
                )
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "For details you can take a look at our",
                " ",
                _react2.default.createElement(
                  _Link2.default,
                  { href: "/cookiepolicy", className: _link },
                  "Cookie Policy"
                ),
                "\xA0here."
              ),
              _react2.default.createElement(
                "p",
                { className: "li1" },
                _react2.default.createElement(
                  "strong",
                  null,
                  "5. Your Rights on the Collection, Use and Distribution of Personal Data"
                )
              ),
              _react2.default.createElement(
                "ul",
                { className: "ul1" },
                _react2.default.createElement(
                  "p",
                  { className: "li1" },
                  _react2.default.createElement(
                    "strong",
                    null,
                    "5.1 Opt In/Opt Out"
                  )
                )
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "We allow you to monitor the way in which we use the personal information we obtain. Any promotional materials which We may send to you (e.g. \"newsletters\" or \"information bulletins\") contain internal mechanisms that allow you to block future mailings (Opt-out)."
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "We also allow you to control if you want to share app usage data related to our Mixer and Bridge apps. These apps have built in mechanisms that allow you to opt out of sharing this information with us."
              ),
              _react2.default.createElement(
                "ul",
                { className: "ul1" },
                _react2.default.createElement(
                  "p",
                  { className: "li1" },
                  _react2.default.createElement(
                    "strong",
                    null,
                    "5.2 Right to Access, Rectify, Modify, Erase and Object"
                  )
                )
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "You have the right to request access, rectification, or erasure of your data that we have collected."
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "You also have the right to object or restrict, for legitimate purposes, the processing of your Personal Data, as well as the right to data portability. In case of restriction we may not be able to provide certain Services to you."
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "You may also withdraw your consent on receiving marketing communications and on sharing your data with us."
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "End Users who wish to deactivate their account may do so in accordance with the terms in the EULA (End User License Agreement). Removed information may persist in backup copies for a reasonable period of time but will not be generally available to other End Users of the Software."
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "Removed information is retained for our own internal accounting purposes along with furnishing customer requests for old invoices."
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "You will not have to pay a fee to access your personal data (or to exercise any of the other rights). However, we may charge a reasonable fee if your request is clearly unfounded, repetitive or excessive. Alternatively, we may refuse to comply with your request in these circumstances."
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "We may need to request specific information from you to help us confirm your identity and ensure your right to access your personal data (or to exercise any of your other rights). This is a security measure to ensure that personal data is not disclosed to any person who has no right to receive it. We may also contact you to ask you for further information in relation to your request to speed up our response."
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "We try to respond to all legitimate requests within one month. Occasionally it may take us longer than a month if your request is particularly complex or you have made a number of requests. In this case, we will notify you and keep you updated."
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "If you wish to exercise any of the rights set out above, please email us at\xA0",
                _react2.default.createElement(
                  _Link2.default,
                  {
                    className: _link,
                    target: "_blank",
                    href: "mailto:legal@quixel.se"
                  },
                  "legal@quixel.se"
                ),
                ". Furthermore, you have a right to lodge a complaint regarding our processing of your data with the supervisory authority in the EU member state of your residence, place of work or place of the alleged infringement."
              ),
              _react2.default.createElement(
                "p",
                { className: "li1" },
                _react2.default.createElement(
                  "strong",
                  null,
                  "6. Data Retention."
                )
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "We will only retain your personal data for as long as necessary to fulfil the purposes we collected it for, including for the purposes of satisfying any legal, accounting, or reporting requirements."
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "To determine the appropriate retention period for personal data, we consider the amount, nature, and sensitivity of the personal data, the potential risk of harm from unauthorised use or disclosure of your personal data, the purposes for which we process your personal data and whether we can achieve those purposes through other means, and the applicable legal requirements."
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "By law we have to keep basic information about our customers (including Contact, Identity, Financial and Transaction Data) for seven years after they cease being customers for accounting and tax purposes."
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "In some circumstances we may anonymise your personal data (so that it can no longer be associated with you) for research or statistical purposes in which case we may use this information indefinitely without further notice to you."
              ),
              _react2.default.createElement(
                "p",
                { className: "li1" },
                _react2.default.createElement(
                  "strong",
                  null,
                  "7. Sharing and Disclosure of Personal Data."
                )
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "We do not sell your data to any third party for marketing purposes. As a general rule, we will not forward your Personal Data to third parties without your permission. However, since we work in conjunction with partners, affiliated companies and third parties for the provisioning of our Services, we may have to share your personal data with them."
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "We may also disclose or share your data with:"
              ),
              _react2.default.createElement(
                "ul",
                { className: "ul1" },
                _react2.default.createElement(
                  "ul",
                  { className: "ul1" },
                  _react2.default.createElement(
                    "li",
                    { className: "li1" },
                    "Service providers who provide IT and system administration services."
                  ),
                  _react2.default.createElement(
                    "li",
                    { className: "li1" },
                    "Subsidiaries or other group companies."
                  ),
                  _react2.default.createElement(
                    "li",
                    { className: "li1" },
                    "Affiliated Parties."
                  ),
                  _react2.default.createElement(
                    "li",
                    { className: "li1" },
                    "Professional advisers including lawyers, bankers, auditors and insurers who provide consultancy, banking, legal, insurance and accounting services."
                  )
                )
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "We only allow such third parties to process your personal data for specified purposes and in accordance with our instructions and applicable data protection law."
              ),
              _react2.default.createElement(
                "ul",
                { className: "ul1" },
                _react2.default.createElement(
                  "ul",
                  { className: "ul1" },
                  _react2.default.createElement(
                    "li",
                    { className: "li1" },
                    _react2.default.createElement(
                      "strong",
                      null,
                      "Legally Compelled Disclosures"
                    )
                  )
                )
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "We may disclose your Personal Data if required to do so by law or if we believe that such action is necessary to (a) conform to the law, comply with a judicial or court order or comply with legal process served on us or Affiliated Parties; (b) protect and defend our rights and property, the services, the users of the services, and/or our Affiliated Parties; or (c) act under circumstances to protect the safety of users of our services, us, or third parties."
              ),
              _react2.default.createElement(
                "p",
                { className: "li1" },
                _react2.default.createElement(
                  "strong",
                  null,
                  "8. International Data Transfers"
                )
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "We are based in Sweden, and your Personal Data is collected and processed in accordance with Swedish privacy laws and EU General Data Protection Regulation."
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "We strive to process all your data inside the EU/EEA (European Union/European Economic Area). However, we may share, store and process your information with our affiliates or third parties, out of which some may be located in countries outside the EU/EEA, such as the United States and any other country in which we maintain our facilities. When personal data is shared or transferred under these circumstances, we will ensure that the transfer will be subject to appropriate safeguards in accordance with applicable data protection legislation and that the level of protection is equivalent to that applicable in the EU/EEA."
              ),
              _react2.default.createElement(
                "p",
                { className: "li1" },
                _react2.default.createElement(
                  "strong",
                  null,
                  "9. Security"
                )
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "We have taken steps to ensure that the Personal Data we collect is secure. We have also taken a range of technical and organizational measures to protect the confidentiality, security, and integrity of the Personal Data collected from you including protecting your data from unauthorized access, loss, change or deletion. Personal Data is stored in secure operating environments that are not available to the public and that are only accessible to authorized employees, consultants and/or service providers."
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "We also have security measures in place to protect the loss, misuse, and alteration of the information under our control. Such actions include, but are not limited to, physical controls, encryption, eligibility restrictions, policies, etc."
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "We have put in place procedures to deal with any suspected personal data breach and will notify you and any applicable regulator of a breach where we are legally required to do so."
              ),
              _react2.default.createElement(
                "p",
                { className: "li1" },
                _react2.default.createElement(
                  "strong",
                  null,
                  "10. Privacy of Minors"
                )
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "Our Services are not meant to be used by anyone under the age of 13. We do not knowingly collect Personal Data such as name and email address from children under 13 years old in the Service, unless expressly permitted by parent or guardian. We believe it is important to safeguard the privacy of children and encourage parents to regularly take an interest in their children\u2019s use of online activities. If you are a parent and believe that your child under the age of 13 has used the Service and provided Personal Data to us, please contact us at\xA0",
                _react2.default.createElement(
                  _Link2.default,
                  {
                    className: _link,
                    target: "_blank",
                    href: "mailto:legal@quixel.se"
                  },
                  "legal@quixel.se"
                ),
                "\xA0and we will delete your child\u2019s account and any related Personal Data."
              ),
              _react2.default.createElement(
                "p",
                { className: "li1" },
                _react2.default.createElement(
                  "strong",
                  null,
                  "11. Governing Law"
                )
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "For Megascans, any dispute, controversy or claim arising out of or in connection with this Privacy Policy, or the breach, termination or invalidity thereof, shall be governed by the laws and venue as stated in sections 28-30 of the End User License Agreement\xA0",
                _react2.default.createElement(
                  _Link2.default,
                  { className: _link, href: "/terms" },
                  "https://quixel.com/terms"
                )
              ),
              _react2.default.createElement(
                "p",
                { className: "li1" },
                _react2.default.createElement(
                  "strong",
                  null,
                  "12. Changes to our Privacy Policy"
                )
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "This Privacy Policy may be subject to change from time to time. If substantial changes are made to the Privacy Policy, we will notify you of these material changes by posting them on the Service and/or informing you by e-mail sent to the address provided by you to us, or if possible in some other manner. You are encouraged to check back and review this Privacy Policy from time to time so that you will always know what information is collected, how it is used and to whom it is disclosed. Your continued use of the Service subject to this Privacy Policy will signify your acceptance of Privacy Policy changes."
              ),
              _react2.default.createElement(
                "p",
                { className: "li1" },
                _react2.default.createElement(
                  "strong",
                  null,
                  "13. Contact."
                ),
                "\xA0 If you have any questions about this Policy, please contact us at\xA0",
                _react2.default.createElement(
                  _Link2.default,
                  {
                    className: _link,
                    target: "_blank",
                    href: "mailto:legal@quixel.se"
                  },
                  "legal@quixel.se"
                ),
                "\xA0or"
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "If you reside in the United States of America at:"
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "Epic Games, Inc., located at located at 620 Crossroads Blvd., Cary, NC 27518, USA."
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "If you reside outside of the United States of America at:"
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "Epic Games International S.\xE0 r.l., a Luxembourg Soci\xE9t\xE9 \xE0 Responsibilit\xE9 Limit\xE9e, located at Atrium Business Park, 33 rue du Puits Romain, L8070 Bertrange, Grand-Duchy of Luxembourg, acting through its Swiss branch, having its principal business offices at Platz 3, 6039 Root, Switzerland.",
                _react2.default.createElement(
                  "span",
                  { className: "Apple-converted-space" },
                  "\xA0 "
                ),
                _react2.default.createElement("br", null),
                " ",
                _react2.default.createElement("br", null),
                " ",
                _react2.default.createElement("br", null)
              )
            ),
            _react2.default.createElement(
              "div",
              { className: _hr },
              _react2.default.createElement(_Hr2.default, null)
            )
          )
        )
      );
    }
  }]);
  return ToS;
}(_react.Component), _class.contextTypes = {
  dialogs: _react2.default.PropTypes.object
}, _temp);
exports.default = ToS;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/ToS/ToS.jsx
// module id = 3035
// module chunks = 0